import {
  ITenant,
  TenantDocumentType,
} from '../entities/ITenant';
import { httpClient } from './helper/httpClient';

export interface ICreateTenantParams {
  name: string;
}

export interface ICreateTenantResponse {
  id: string;
  name: string;
  active: boolean;
  birthPhotographerMode: boolean;
  createdAt: string;
}

export interface IUpdateTenantSettingsParams {
  birthPhotographerMode: boolean;
}

export interface IUpdateBillingInfoParams {
  documentType: TenantDocumentType;
  documentNumber: string;
}

export interface IBillingInfoDocumentResponse {
  documentType: TenantDocumentType | null;
  documentNumber: string | null;
}

export interface ITenantSignInResponse extends ITenant {
  tenantId?: string;
}

export interface IEnableLeadCaptureResponse {
  token: string;
  publicUrl: string;
}

class TenantService {
  private _baseURL = 'tenants';

  create({ name }: ICreateTenantParams): Promise<ICreateTenantResponse> {
    return httpClient.post<ICreateTenantParams, ICreateTenantResponse>(
      `${this._baseURL}`,
      { name },
    );
  }

  signin(id: string): Promise<ITenantSignInResponse> {
    return httpClient.post<string, ITenantSignInResponse>(
      `${this._baseURL}/signin`,
      {
        tenantId: id,
      },
    );
  }

  update(id: string, name: string): Promise<ITenant> {
    return httpClient.patch<null, ITenant>(`${this._baseURL}/${id}`, {
      name,
    });
  }

  updateSettings(data: IUpdateTenantSettingsParams): Promise<ITenant> {
    return httpClient.patch<IUpdateTenantSettingsParams, ITenant>(
      `${this._baseURL}/me/settings`,
      data,
    );
  }

  updateBillingInfo(data: IUpdateBillingInfoParams): Promise<ITenant> {
    return httpClient.patch<IUpdateBillingInfoParams, ITenant>(
      `${this._baseURL}/me/billing-info`,
      data,
    );
  }

  getBillingInfoDocument(): Promise<IBillingInfoDocumentResponse> {
    return httpClient.get<null, IBillingInfoDocumentResponse>(
      `${this._baseURL}/me/billing-info/document`,
    );
  }

  enableLeadCapture(): Promise<IEnableLeadCaptureResponse> {
    return httpClient.post<null, IEnableLeadCaptureResponse>(
      `${this._baseURL}/lead-capture`,
    );
  }

  disableLeadCapture(): Promise<void> {
    return httpClient.delete(`${this._baseURL}/lead-capture`);
  }
}

export default new TenantService();
